import App from "./App.svelte"

function attachSvelteComponent(elementID, class_) {
	let svelteElement = document.getElementById(elementID);
	if (svelteElement) {
		new class_({
			target: svelteElement
		});
	}
}

attachSvelteComponent("app", App);